import { apiClient } from '@/shared/api';

import type {
  AdjustStockRequest,
  ReceiveStockRequest,
  StockAlertPageResponse,
  StockAlertsQueryParams,
  StockItemListResponse,
  StockItemPageResponse,
  StockLedgerEntryPageResponse,
  StockLedgerQueryParams,
  StockListQueryParams,
  StockMutationResponse,
  StockPolicyResponse,
  StockPolicyUpsertRequest,
  StockTransferResponse,
  TransferStockRequest,
} from '../model/types';

const BASE = '/api/v1/inventory/stock';

// ── Stock ────────────────────────────────────────────────────────────────────
export const listStock = async (
  params: StockListQueryParams = {},
): Promise<StockItemPageResponse> =>
  (await apiClient.get<StockItemPageResponse>(BASE, { params })).data;

export const getStockByProduct = async (productId: string): Promise<StockItemListResponse> =>
  (await apiClient.get<StockItemListResponse>(`${BASE}/${productId}`)).data;

// ── Movement ledger ──────────────────────────────────────────────────────────
export const getStockLedger = async (
  params: StockLedgerQueryParams = {},
): Promise<StockLedgerEntryPageResponse> =>
  (await apiClient.get<StockLedgerEntryPageResponse>(`${BASE}/ledger`, { params })).data;

// ── Alerts ───────────────────────────────────────────────────────────────────
export const listStockAlerts = async (
  params: StockAlertsQueryParams = {},
): Promise<StockAlertPageResponse> =>
  (await apiClient.get<StockAlertPageResponse>(`${BASE}/alerts`, { params })).data;

// ── Movements: receipts / adjustments / transfers ───────────────────────────
export const receiveStock = async (body: ReceiveStockRequest): Promise<StockMutationResponse> =>
  (await apiClient.post<StockMutationResponse>(`${BASE}/receipts`, body)).data;

export const adjustStock = async (body: AdjustStockRequest): Promise<StockMutationResponse> =>
  (await apiClient.post<StockMutationResponse>(`${BASE}/adjustments`, body)).data;

export const transferStock = async (body: TransferStockRequest): Promise<StockTransferResponse> =>
  (await apiClient.post<StockTransferResponse>(`${BASE}/transfers`, body)).data;

// ── Policies ─────────────────────────────────────────────────────────────────
export const getStockPolicy = async (
  productId: string,
  locationId: string,
): Promise<StockPolicyResponse> =>
  (await apiClient.get<StockPolicyResponse>(`${BASE}/policies/${productId}/${locationId}`)).data;

export const upsertStockPolicy = async (
  productId: string,
  locationId: string,
  body: StockPolicyUpsertRequest,
): Promise<StockPolicyResponse> =>
  (await apiClient.put<StockPolicyResponse>(`${BASE}/policies/${productId}/${locationId}`, body))
    .data;
